import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useFavoritos } from '../context/FavoritosContext';
import { getProductos } from '../api/productos';
import PosterGrid from '../components/PosterGrid';
import useSEO from '../hooks/useSEO';
import logo from '../logo.jpg';
import './Home.css';

const Favoritos = () => {
  useSEO({
    title: 'Mis Favoritos | MiEstampita',
    description: 'Tus estampitas favoritas en MiEstampita.',
    path: '/favoritos',
    noindex: true,
  });

  const { isLoggedIn } = useAuth();
  // favoritoIds ya vive en FavoritosContext (se carga sola al loguearse) --
  // se deriva la lista mostrada de ahí en vez de guardar una copia propia,
  // así sacar un favorito desde acá (FavoritoButton, dentro de PosterGrid)
  // actualiza esta lista al toque, sin necesitar un refetch manual.
  const { favoritoIds } = useFavoritos();
  const [catalogo, setCatalogo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isLoggedIn) {
      setLoading(false);
      return;
    }
    // GET /favoritos no trae slug/categoría (ver src/api/favoritos.js) --
    // se cruza con el catálogo completo para poder linkear a
    // /personalizar/:slug y reusar PosterGrid tal cual.
    getProductos()
      .then(setCatalogo)
      .catch((err) => setError(err.message || 'No se pudieron cargar tus favoritos.'))
      .finally(() => setLoading(false));
  }, [isLoggedIn]);

  const productos = catalogo.filter((producto) => favoritoIds.has(producto.id));

  if (!isLoggedIn) {
    return (
      <div className="home-page">
        <div className="logo-wrapper">
          <Link to="/">
            <img src={logo} alt="MiEstampita Logo" className="logo" />
          </Link>
        </div>
        <div className="home-wrapper">
          <p>Iniciá sesión para ver tus favoritos.</p>
          <Link to="/login" className="back-to-collection">
            Iniciar sesión
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="home-page">
      <div className="logo-wrapper">
        <Link to="/">
          <img src={logo} alt="MiEstampita Logo" className="logo" />
        </Link>
      </div>
      <div className="home-wrapper">
        <h1 className="category-switcher__title">Mis Favoritos</h1>

        {loading && <p className="collection-hint">Cargando favoritos...</p>}
        {error && <p className="collection-hint">{error}</p>}
        {!loading && !error && productos.length === 0 && (
          <p className="collection-hint">
            Todavía no marcaste ninguna estampita como favorita.{' '}
            <Link to="/coleccion" className="retry-link">
              Ver la colección
            </Link>
          </p>
        )}
        {!loading && productos.length > 0 && <PosterGrid stamps={productos} />}
      </div>
    </div>
  );
};

export default Favoritos;
